import { CoeMyWorkEntityModel } from "src/store/models/entity/coeMyWork/entity";
import { CoeMyWorkHelperModel } from "src/store/models/entity/coeMyWork/helper";

export const encooCoeMyWorkModels = {
  entity: CoeMyWorkEntityModel,
  helper: CoeMyWorkHelperModel,
};
